<template>
  <div>
    <VCard title="Whatsapp Template 🙌">
      <VCardText>Coming Soon</VCardText>
    </VCard>
  </div>
</template>

<script setup>
definePage({
  meta: {
    name: 'app-global-template-whatsapp',
  },  
})
</script>
